import log from 'salvo-lite/log'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'

class Tooltips {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }

    onInit () {
        log.debug(this.constructor.name, 'initialised', this)
        tippy('[data-tippy-content]', {
            arrow: false,
            placement: 'bottom'
        })
    }
}

export default Tooltips



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Tooltips.js